import React from 'react'
import SarasWrapper from '../../container/SarasWrapper'

const FormWrapper = (props) => {
    const { formObject, action, rowKey, headerKey, children, wrapperClass, wrapperStyle, useColStyle, ...restProps } = props;
    
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    let cssStyle, cssClass, style;
    
    if (viewData && hide === "0")
    {
        cssStyle = viewData.dataList.colCssStyle?JSON.parse(viewData.dataList.colCssStyle):'';
        cssClass = viewData.dataList.colCssClass || '';
        style = useColStyle? {...cssStyle, ...wrapperStyle} : {...wrapperStyle};

        return (
            <SarasWrapper {...restProps} wrapperClass={`${wrapperClass || ''} ${cssClass || ''}`} wrapperStyle={style}>
                {children}
            </SarasWrapper>  
        )
    }

    return (null);
}

export default FormWrapper